<template>
  <div class="p-2 sm:p-3 select-none">
    <div class="flex flex-wrap justify-center">
      <!-- Digital Portals section -->
      <div class="min-w-full sm:min-w-30 max-w-5xl m-2 flex-1">
        <div class="bg-white rounded-lg shadow-card p-4 sm:p-12">
          <h1 class="font-semibold text-2xl lg:text-3xl mb-3 text-center">
            Digital Content Portals
          </h1>

          <div v-for="(portals, key) in chunkPortals" :key="key" class="flex sm:flex-row justify-between">
            <section v-for="portal in portals" :key="portal.id"
                     class="flex flex-col justify-center rounded-lg  px-3 py-6 shadow-lg w-1/2 m-5">
              <h1 class="font-semibold text-xl text-center">{{ portal.name }}</h1>
              <div class="object-contain h-32 w-32 mx-auto">
                <img :alt="portal.name" :src="portal.image" class="p-3"/>
              </div>
              <div v-if="portal.price > 0" class="text-center my-3">
                <p class="text-4xl font-bold text-orange-500">${{ portal.price }}</p>
                <p>per month</p>
              </div>
              <div v-else class="text-center my-3">
                <p class="text-4xl font-bold text-orange-500">FREE</p>
              </div>
              <div class="m-3 text-center">
                <p class="text-gray-700">{{ shorten(portal.description, 100) }}</p>
              </div>
              <button :disabled="portal.selected" class="btn btn-primary font-semibold rounded-lg px-10 w-48 mx-auto"
                      @click="addPortal(portal)">
                <span v-if="portal.selected">Added</span>
                <span v-else>Add a Portal</span>
              </button>
            </section>
          </div>


          <!-- bottom navigation -->
          <section class="mt-16">
            <div class="flex flex-col-reverse sm:flex-row justify-between">
              <button
                  class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mt-5 sm:mt-0"
                  @click="$emit('back')"
              >
                <span>Back</span>
              </button>
              <div>
                <button
                    v-if="order.from === 'buildabox'"
                    class="btn btn-secondary font-semibold rounded-lg px-10 min-w-10 mr-3"
                    @click="$emit('submit')"
                >
                  <span>Skip</span>
                </button>
                <button
                    :disabled="!canProceedToNextStep"
                    class="btn btn-primary font-semibold rounded-lg px-10 min-w-10"
                    @click="$emit('submit')"
                >
                  <span>Next</span>
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>

      <!-- Info boxes sidebar -->
      <div>
        <info-box class="m-2">
          Add a portal to this buildabox.co project to instantly reduce or eliminate printing costs, provide attendees
          with a secure environment to access relevant content, provide Virtual Parking Lots for questions and other
          communications and gather valuable content engagement analytics for reporting.
        </info-box>
      </div>
      <!-- ### -->
    </div>
  </div>
</template>

<script>
import ApiV1 from '@/api/api_v1.0'
import Api from '@/api/api_v1.0'
import InfoBox from '../../../../components/common/InfoBox.vue'

export default {
  name      : 'portals',
  components: {
    InfoBox
  },
  data () {
    return {
      progressLoading: false,
      chunkPortals   : [],
    }
  },
  computed: {
    order () {
      return this.$store.state.currentEditingOrder
    },
    canProceedToNextStep () {
      return true
    }
  },
  created () {
    this.getPortals()
  },
  methods: {
    splitIntoChunk (arr, chunk) {
      let res = []
      for (let i = 0; i < arr.length; i += chunk) {
        let tempArray
        tempArray = arr.slice(i, i + chunk)
        res.push(tempArray)
      }
      return res
    },
    async addPortal (portal) {
      await ApiV1.addPortal(this.order.uuid, portal.id)
      const orderResponse = await Api.getOrderDetails(
          this.order.uuid,
      )
      this.$store.commit('setCurrentEditingOrder', orderResponse.data)
      await this.getPortals()
    },
    async getPortals () {
      await ApiV1.getPortals().then(res => {

        let portals = res.data.map(portal => {
          if (this.order.portals.find(p => p.id === portal.id)) {
            return { ...portal, selected: true }
          }

          return { ...portal, selected: false }
        })

        this.chunkPortals = this.splitIntoChunk(portals, 2)
      })
    }
  }
}
</script>
